import {Component, Input} from '@angular/core';

/**
 * Generated class for the SellionsTipComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'sellions-tip',
  templateUrl: 'sellions-tip.html'
})
export class SellionsTipComponent {
  @Input()tipContent;
  @Input()tipTitle;

  constructor() {}

}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-tip/sellions-tip.ts